
import hcHeroBanner from '../widgets/hcHeroBanner.js';
import hcCards from "../widgets/hcCards.js";

export default function secondaryThemeWidget() {
    const subPageToTrigger = 'HC-Homepage'
    const body = $("body");
    const targetContainer = "content";
    const contentCustomClass = "subThemeHomePage";
    const noBannerClass = "hcHeroBanner-no-data";
    const noCardsClass = "hcCards-no-data";


    const subPageLayout = {
        subPageContainer: $('<div class="subpageContainer"></div>'),
        heroBanner: $(`
                        <div class="heroBannerContainer">
                            <div class="blurEffect"></div>
                            <div class="heroMainImage"></div>
                        </div>
                    `),
        pageTitle: $('<div class="pageTitle"></div>'),
        subPageCards: $('<div class="subPageCards"></div>'),

        addBanner() {
            if (!validateBodyClass(noBannerClass)) {
                this.subPageContainer.append(this.heroBanner);
            }
        },

        addCards() {
            if (!validateBodyClass(noCardsClass)) {
                $(`.${contentCustomClass}`).prepend(this.subPageCards);
            }
        },

        addTitle() {
            this.subPageContainer.append(this.pageTitle);
        }
    };




    function validateBodyClass(classCheck) {
        return body.hasClass(classCheck);
    }




    (function validateSubThemeStage() {
        if (validateBodyClass(subPageToTrigger)) {
            applyHomepageLayout();
        }
    })();


    function applyHomepageLayout() {
        hcHeroBanner();
        hcCards();
        buildLayout();
    }


    function buildLayout() {
        $(`.${targetContainer}`).addClass(contentCustomClass);
        $(`.${contentCustomClass}`).before(buildLayoutObject())
    }


    function buildLayoutObject() {
        subPageLayout.addBanner();
        subPageLayout.addCards();
        subPageLayout.addTitle();
        return subPageLayout.subPageContainer;
    }
}